<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Usuários de Experiências</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="options"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 30, 50],
          itemsPerPageText: 'Registros por página:'
        }"
      >
        <template v-slot:item.telefone="{ item }">
          {{ item.telefone }}
        </template>
        <template v-slot:item.cpf="{ item }">
          {{ item.cpf }}
        </template>
      </v-data-table>
    </v-container>
  </v-main>
</template>

<script>
import Quicksearch from '@/components/Quicksearch'

export default {
  name: 'experienceUsers',
  components: {
    Quicksearch
  },
  data: () => ({
    loading: false,
    quicksearch: '',
    items: [],
    totalItems: 0,
    options: {
      sortBy: ['ultimaAtualizacao'],
      sortDesc: [true]
    },
    searchTimeout: null,
    headers: [
      {
        text: 'Nome',
        value: 'nome'
      },
      {
        text: 'E-mail',
        value: 'email'
      },
      {
        text: 'Telefone',
        value: 'telefone'
      },
      {
        text: 'CPF',
        value: 'cpf'
      },
      {
        text: 'Login',
        value: 'tipoLogin'
      },
      {
        text: 'Última Atualização',
        value: 'ultimaAtualizacao'
      }
    ]
  }),
  computed: {
    noResultText () {
      return 'Nenhum usuário encontrado'
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    },
    quicksearch () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.options.page = 1
        this.getData()
      }, 500)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options
        const params = {
          page: page || 1,
          limit: itemsPerPage || 30,
          search: this.quicksearch || '',
          sortBy: sortBy && sortBy.length > 0 ? sortBy[0] : '',
          sortDesc: sortBy && sortBy.length > 0 ? (sortDesc[0] ? 'DESC' : 'ASC') : ''
        }

        const response = await this.$http.get('https://n8n.heppi.io/webhook/c116378d-38a8-4c2a-a4c8-c566420312dc', { params })

        if (response.data.success) {
          this.items = response.data.data
          this.totalItems = response.data.total
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          message: 'Erro ao carregar usuários',
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    // getData será chamado automaticamente pelo watcher de options
  }
}
</script>
